import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const colorRed = tokenDefinition({
    name: TokenName.COLOR_RED,
    type: TokenType.KEYWORD,
    tokenMatcher: /^RED/,
    contentMatcher: /^RED/
});

const colorBlue = tokenDefinition({
    name: TokenName.COLOR_BLUE,
    type: TokenType.KEYWORD,
    tokenMatcher: /^BLUE/,
    contentMatcher: /^BLUE/
});

const colorGreen = tokenDefinition({
    name: TokenName.COLOR_GREEN,
    type: TokenType.KEYWORD,
    tokenMatcher: /^GREEN/,
    contentMatcher: /^GREEN/
});

const colorNames = [colorRed.name, colorBlue.name, colorGreen.name]

class Color {

    constructor() {
    }

    consume(tokenIterator, nodeIterator) {

        if(this.isOpening(tokenIterator)) {
            this.openNewNode(tokenIterator, nodeIterator)
        } else if(this.isClosing(tokenIterator)) {
            this.closeNode(tokenIterator, nodeIterator)
        }

    }

    onEndOfMarkup(openNode) {
        openNode.cancel()
    }

    toHtml(node, toHtml, idProvider) {
        var content = ""
        for(const child of node.children) {
            content += toHtml(child, idProvider)
        }

        const colorCode = node.value.replace("COLOR_", "").toLowerCase()
        // TODO refactor so that front decide the color code of each given color
        return "<span class='color-" + colorCode + "'>" + content + "</span>"
    }

    isOpening(tokenIterator) {
        return tokenIterator.hasNext(2)
            && tokenIterator.tokens[tokenIterator.index].name === TokenName.OPEN_SPECIAL
            && this.isColorCode(tokenIterator.peekNext(1))
            && tokenIterator.peekNext(2).name === TokenName.PIPE

    }

    isColorCode(token) {
        return colorNames.includes(token.name)
    }

    isClosing(tokenIterator) {
        return tokenIterator.token().name === TokenName.CLOSE_SPECIAL
    }

    openNewNode(tokenIterator, nodeIterator) {

        let colorName = tokenIterator.tokens[tokenIterator.index + 1].name;

        nodeIterator.addOpenNode(new Node(
            NodeName.COLOR,
            colorName,
            new Color(),
            nodeIterator.currentParentNode
        ));

        tokenIterator.eatTokens(3)
    }

    closeNode(tokenIterator, nodeIterator) {
        // find color node and close it
        let openNodeIndex = nodeIterator.indexOfLastOpen(NodeName.COLOR)
        if(openNodeIndex === null) return
        nodeIterator.closeNodeAtIndex(openNodeIndex);
        tokenIterator.eatTokens(1)
    }

}

export {colorRed, colorBlue, colorGreen, colorNames, Color}
